import {Inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";
import {first, take} from "rxjs/operators";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {Observable, ReplaySubject} from "rxjs";
import {SharedFile} from "../interface/shared-file";
import {FileManager} from "../interface/file-manager";

@Injectable({
  providedIn: 'root'
})
export class SharedFileService {
  private readonly sharedFileListSubject: ReplaySubject<CountedAndPaginated<SharedFile>>
    = new ReplaySubject<CountedAndPaginated<SharedFile>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document
  ) {
  }

  public getSharedFileListSubject(): ReplaySubject<CountedAndPaginated<SharedFile>> {
    return this.sharedFileListSubject;
  }

  public loadList(filters: object , page: number, pageSize: number): void {
    this.httpClient.get(`/rest/crm/shared-file?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<SharedFile>) => {
        this.sharedFileListSubject.next(result);
      });
  }

  public send(formData: object): Observable<any> {
    return this.httpClient.post(`/rest/crm/file-manager/shared-file`, formData)
      .pipe(
        take(1)
      );
  }
  public add(uuid: string, formData: object): Observable<any> {
    return this.httpClient.post(`/rest/crm/file-manager/shared-file/${uuid}/file`, formData)
      .pipe(
        take(1)
      );
  }
  public deleteSharedFile(uuid: string): Observable<any> {
    return this.httpClient.delete(`/rest/crm/file-manager/shared-file/${uuid}`)
      .pipe(first());
  }

}
